export default "__VITE_ASSET__5QDnXQR9__"